/* AFBDECOR mobile collection/search 1/2-column controller. Styling lives in afb-polish-pass.css. */
(() => {
  const MOBILE_MAX = 989;
  const STORAGE_KEY = 'afb_mobile_grid_columns';
  const GRID_SELECTOR = '#ProductGridContainer #product-grid.grid.product-grid, .template-search #ProductGridContainer .product-grid';
  const HOST_SELECTOR = '#main-collection-filters .facets-container, #main-search-filters .facets-container';
  const QUALITY_STYLE_ID = 'afb-quality-product-meta-style';

  const isMobile = () => window.innerWidth <= MOBILE_MAX;
  const getGrid = () => document.querySelector(GRID_SELECTOR);

  function savedColumns() {
    try { return Number(localStorage.getItem(STORAGE_KEY)) === 1 ? 1 : 2; }
    catch (e) { return 2; }
  }

  function saveColumns(value) {
    try { localStorage.setItem(STORAGE_KEY, String(value)); } catch (e) {}
  }

  function makeButton(columns) {
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.afbMobileColumns = String(columns);
    button.setAttribute('aria-label', columns === 1 ? 'Show one product per row' : 'Show two products per row');
    button.setAttribute('title', columns === 1 ? '1 product per row' : '2 products per row');
    button.innerHTML = columns === 1
      ? '<span class="afb-view-one-icon" aria-hidden="true"></span>'
      : '<span class="afb-view-two-icon" aria-hidden="true"><i></i><i></i><i></i><i></i></span>';
    return button;
  }

  function ensureControls() {
    if (!isMobile()) {
      document.querySelectorAll('.afb-mobile-view-toggle').forEach(control => control.remove());
      return;
    }

    document.querySelectorAll(HOST_SELECTOR).forEach(host => {
      let controls = host.querySelector('.afb-mobile-view-toggle');
      if (!controls) {
        controls = document.createElement('div');
        controls.className = 'afb-mobile-view-toggle';
        controls.setAttribute('role', 'group');
        controls.setAttribute('aria-label', 'Products per row');
        controls.appendChild(makeButton(1));
        controls.appendChild(makeButton(2));
        host.appendChild(controls);
      }
      if (controls.dataset.afbMobileReady === '1') return;
      controls.dataset.afbMobileReady = '1';
      controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-afb-mobile-columns]');
        if (!button) return;
        event.preventDefault();
        applyMobile(Number(button.dataset.afbMobileColumns), true);
      });
    });
  }

  function clearMobileClasses(grid) {
    if (!grid) return;
    grid.classList.remove('afb-mobile-grid-cols-1', 'afb-mobile-grid-cols-2');
    grid.removeAttribute('data-afb-mobile-grid');
  }

  function applyMobile(columns, persist = false) {
    const grid = getGrid();
    if (!grid) return;
    if (!isMobile()) {
      clearMobileClasses(grid);
      return;
    }

    const value = columns === 1 ? 1 : 2;
    grid.classList.remove('afb-mobile-grid-cols-1','afb-mobile-grid-cols-2','afb-grid-cols-2','afb-grid-cols-3','afb-grid-cols-4','afb-grid-cols-6');
    grid.classList.add(`afb-mobile-grid-cols-${value}`);
    grid.setAttribute('data-afb-mobile-grid', String(value));
    document.querySelectorAll('.afb-mobile-view-toggle [data-afb-mobile-columns]').forEach(button => {
      button.setAttribute('aria-pressed', Number(button.dataset.afbMobileColumns) === value ? 'true' : 'false');
    });
    if (persist) saveColumns(value);
  }

  function imagePath(img) {
    if (!img) return '';
    try {
      return new URL(img.currentSrc || img.src || '', window.location.href).pathname;
    } catch (e) {
      return '';
    }
  }

  function ensureQualityMetaStyles() {
    if (!document.head || document.getElementById(QUALITY_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = QUALITY_STYLE_ID;
    style.textContent = `
      .afb-bloxic-home .afb-quality-visual{
        position:relative!important;
        padding-bottom:82px!important;
      }
      .afb-bloxic-home .afb-quality-product-meta{
        position:absolute;
        left:30px;
        right:30px;
        bottom:22px;
        z-index:3;
        text-align:center;
      }
      .afb-bloxic-home .afb-quality-product-meta__name{
        display:block;
        color:#171717;
        text-decoration:none;
        font-family:"Poppins",var(--font-body-family),Arial,sans-serif;
        font-size:13px;
        line-height:1.35;
        font-weight:500;
      }
      .afb-bloxic-home .afb-quality-product-meta__name:hover{color:var(--afb-red)}
      .afb-bloxic-home .afb-quality-product-meta .afb-product-card__price{
        justify-content:center;
        margin-top:5px;
        font-size:12px;
      }
      @media screen and (max-width:749px){
        .afb-bloxic-home .afb-quality-visual{padding-bottom:74px!important}
        .afb-bloxic-home .afb-quality-product-meta{
          left:18px;
          right:18px;
          bottom:16px;
        }
        .afb-bloxic-home .afb-quality-product-meta__name{font-size:12px}
        .afb-bloxic-home .afb-quality-product-meta .afb-product-card__price{font-size:11.5px}
      }
    `;
    document.head.appendChild(style);
  }

  function ensureQualityProductMeta() {
    const root = document.querySelector('.afb-bloxic-home');
    if (!root) return;

    const visual = root.querySelector('.afb-quality-visual');
    if (!visual || visual.querySelector('.afb-quality-product-meta')) return;

    const cards = Array.from(root.querySelectorAll('.afb-products-section .afb-product-card'));
    if (!cards.length) return;

    const qualityImagePath = imagePath(visual.querySelector('img'));
    let sourceCard = qualityImagePath
      ? cards.find(card => imagePath(card.querySelector('.afb-product-card__image img')) === qualityImagePath)
      : null;
    if (!sourceCard) sourceCard = cards[0];

    const titleLink = sourceCard.querySelector('.afb-product-card__info h3 a');
    const price = sourceCard.querySelector('.afb-product-card__price');
    if (!titleLink || !price) return;

    ensureQualityMetaStyles();

    const meta = document.createElement('div');
    meta.className = 'afb-quality-product-meta';

    const name = document.createElement('a');
    name.className = 'afb-quality-product-meta__name';
    name.href = titleLink.href;
    name.textContent = titleLink.textContent.trim();
    meta.appendChild(name);

    const priceClone = price.cloneNode(true);
    priceClone.classList.add('afb-quality-product-meta__price');
    meta.appendChild(priceClone);

    visual.appendChild(meta);
  }

  function init() {
    ensureControls();
    applyMobile(savedColumns(), false);
    ensureQualityProductMeta();
  }

  function observeChanges() {
    if (!document.body || document.body.dataset.afbMobileGridObserver === '1') return;
    document.body.dataset.afbMobileGridObserver = '1';
    let timer;
    new MutationObserver(mutations => {
      const relevant = mutations.some(mutation => Array.from(mutation.addedNodes).some(node => {
        if (!(node instanceof Element)) return false;
        return node.matches?.('#ProductGridContainer,#product-grid,#main-collection-filters,#main-search-filters,.facets-container,.afb-bloxic-home,.afb-quality-visual,.afb-products-section') || node.querySelector?.('#ProductGridContainer,#product-grid,#main-collection-filters,#main-search-filters,.facets-container,.afb-bloxic-home,.afb-quality-visual,.afb-products-section');
      }));
      if (!relevant) return;
      clearTimeout(timer);
      timer = setTimeout(init, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 120);
  });
  window.addEventListener('orientationchange', () => setTimeout(init, 180));
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); observeChanges(); });
  } else {
    init();
    observeChanges();
  }
})();
